import { Field, ErrorMessage } from "formik"
import { useState, useEffect } from "react";
import CreditCardInputs from "./CreditCardInputs"
import VoucherInputs from "./VoucherInputs";

export default function Pago({ productos, setModal, setFieldValue, values, errors, touched, enableVoucher }) {

    useEffect(() => {
      
        setTotal(()=> productos.reduce((acc, producto) => {
            let { Unidad, Precio, qty } = producto;
            if (Number.isNaN(Precio)) Precio = Number(Precio.replace(/Q/g, '').trim())
            return acc + (Unidad * Precio * qty);
         }, 0)
         
         )
    }, [productos])
    
   const [total, setTotal] = useState(()=>

       productos.reduce((acc, producto) => {
           let { Unidad, Precio, qty } = producto;
           if (Number.isNaN(Precio)) Precio = Number(Precio.replace(/Q/g, '').trim())
           return acc + (Unidad * Precio * qty);
        }, 0)
        
        )
    const [subtotal, setSubtotal] = useState(0)
    const handleBlur = (e, setFieldValue, flag) => {

        /*if(e.target.value > total){    
            setFieldValue(flag, total)
            setFieldValue('efectivo', 0)
        }*/

        const { efectivo, tarjeta, /*voucher*/ } = values;
        const voucher = enableVoucher ? values.voucher : null

        const subtotal = enableVoucher 
            ? Number(efectivo) + Number(tarjeta) + Number(voucher)
            : Number(efectivo) + Number(tarjeta)

        setSubtotal(()=>String(subtotal))

        setFieldValue('monto', total);
    }

    const handleChange = (e, setFieldValue, flag) => {
  //console.log(total)
  //console.log(subtotal)
        const isEmpty = productos.some(item => item.qty === 0)

        if(productos.length === 0){
            setFieldValue('tarjeta', '')
            setFieldValue('efectivo', '')
            return setModal({
                msg: 'Seleccione un producto para ingresar formas de pago.',
                ok: false,
                show: true
            })
        }

        if(isEmpty){
            setFieldValue('tarjeta', '')
            setFieldValue('efectivo', '')
            return setModal({
                msg: 'Ingrese la cantidad en todos los productos.',
                ok: false,
                show: true
            })
        }
        setFieldValue(flag, e.target.value)
    }

    return (
            <div className="px-4 py-5 sm:p-6">
                <div className="lg:grid lg:grid-cols-3 lg:gap-5 ml-3">
                    <div className="lg:col-span-1">
                        <h3 className="text-lg font-medium leading-6 text-white">4. Forma de pago</h3>
                        <p className="py-2 text-sm text-grisMira">Rellene la información respectiva a las formas de pago.</p>
                        
                    </div>
                    <div className="mt-5 lg:col-span-2 lg:mt-0">
                        <div className="grid grid-cols-6 gap-3">
                            <div className="order-last col-span-full bg-primarioMira px-5 flex items-center justify-between border-t border-gray-200 mt-5 pt-5 text-gray-900">
                                <p className="text-base font-semibold text-grisMira">Subtotal</p>
                                <p className="text-base font-semibold text-white">
                                    <span className={`${Number(total) === Number(subtotal) ? 'bg-green-500/80' : 'bg-red-500/80'} px-2 py-1 rounded-full`}>
                                        {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(subtotal)}
                                    </span>
                                </p>
                            </div>
                            <div className="order-last col-span-full bg-secundarioMira p-5 flex items-center justify-between border-t border-gray-200 mt-5 pt-5 text-gray-900">
                                <p className="text-base font-semibold text-grisMira">Total</p>
                                
                                <p className="text-base font-semibold text-white">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(total)}</p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                <div className="flex justify-between">    
                                    <label className="block text-sm font-medium text-grisMira">
                                        Monto Pago Efectivo
                                    </label>
                                    <ErrorMessage component="p" name="efectivo" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                </div>
                                <Field
                                    onKeyUp={(e) => handleBlur(e, setFieldValue, 'efectivo')}
                                    onChange={(e) => handleChange(e, setFieldValue, 'efectivo')}
                                    name='efectivo'
                                    type='number'
                                    min={0}
                                    step={0.01}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                <div className="flex justify-between">    
                                    <label className="block text-sm font-medium text-grisMira">
                                        Monto Pago Tarjeta
                                    </label>
                                    <ErrorMessage component="p" name="tarjeta" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                </div>
                                <Field
                                    onKeyUp={(e) => handleBlur(e, setFieldValue, 'tarjeta')}
                                    onChange={(e) => handleChange(e, setFieldValue, 'tarjeta')}
                                    name='tarjeta'
                                    type='number'
                                    min={0}
                                    step={0.01}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                            </div>

                            {enableVoucher &&
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                <div className="flex justify-between">    
                                    <label className="block text-sm font-medium text-grisMira">
                                        Monto Pago Voucher
                                    </label>
                                    <ErrorMessage component="p" name="voucher" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                </div>
                                <Field
                                    onKeyUp={(e) => handleBlur(e, setFieldValue, 'voucher')}
                                    onChange={(e) => handleChange(e, setFieldValue, 'voucher')}
                                    name='voucher'
                                    type='number'
                                    min={0}
                                    step={0.01}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                />
                            </div>}

                            {
                                values.tarjeta > 0 ?
                                    <CreditCardInputs
                                        setModal={setModal}
                                        setFieldValue={setFieldValue}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                    />
                                : null
                            }

                            {enableVoucher &&
                                values.voucher > 0 ?
                                    <VoucherInputs
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        errors={errors}
                                    />
                                : null
                            }

                        </div>
                    </div>
                </div>
            </div>
    )
}